import styled, { css } from "styled-components"
import { getColorFromVariant } from "../utils"

const fontSize = (size) => {
  switch (size) {
    case "smallv2":
      return "2rem"
    case "small":
      return "1.5rem"
    case "medium":
      return "2.5rem"
    case "large":
      return "3rem"
    case "1xlarge":
      return "3.5rem"
    case "2xlarge":
      return "4rem"
    case "3xlarge":
      return "4.5rem"
    default:
      return "2rem"
  }
}

export const styles = css`
  color: ${({ variant }) => getColorFromVariant(variant)};
  font-size: ${({ size }) => fontSize(size)};
  font-family: ${({ theme }) => theme.fonts.headings.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.headings.weight};
  letter-spacing: -1px;
  line-height: 1.2;

  ${(props) =>
    !!props.marginless &&
    css`
      margin: 0;
    `}
`

export const StyledH1 = styled.h1`
  ${styles}
`
